import ActivityStreamModule from './activity-stream.module'

export default ActivityStreamModule
